/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */

// import api from '@bmp-vue/core/api'
// const TipoPerfilOperador = api.Enums.TipoPerfilOperador

export default [
  {
    title: 'Dashboard',
    icon: 'fas fa-home',
    path: '/dashboard',
    view: 'Dashboard',
    dir: 'views/app/',
    menu: true,
    meta: {
      anonymousAuth: false
    }
  },
  {
    title: 'Clients',
    icon: 'fas fa-desktop',
    path: '/clients',
    view: 'Clients',
    dir: 'views/app/clients/',
    menu: true,
    meta: {
      anonymousAuth: false
    }
  },
  {
    title: 'Identity Resources',
    icon: 'fas fa-id-badge',
    path: '/identityResources',
    view: 'IdentityResources',
    dir: 'views/app/identityresources/',
    menu: true,
    meta: {
      anonymousAuth: false
    }
  },
  {
    title: 'Protected Resources',
    icon: 'fas fa-cloud',
    path: '/protectedResources',
    view: 'ProtectedResources',
    dir: 'views/app/protectedresources/',
    menu: true,
    meta: {
      anonymousAuth: false
    }
  },
  {
    title: 'Groups',
    icon: 'fas fa-users',
    path: '/groups',
    view: 'Groups',
    dir: 'views/app/groups/',
    menu: true,
    meta: {
      anonymousAuth: false
    }
  },
  {
    title: 'Users',
    icon: 'fas fa-user',
    path: '/users',
    view: 'Users',
    dir: 'views/app/users/',
    menu: true,
    meta: {
      anonymousAuth: false
    }
  },
  {
    title: 'Configurations',
    icon: 'fas fa-cogs',
    path: '/globalconfigurations',
    view: 'Configurations',
    dir: 'views/app/globalconfigurations/',
    menu: true,
    meta: {
      anonymousAuth: false
    }
  },
  {
    path: '/loginafter',
    view: 'LoginAfter',
    dir: 'views/',
    title: 'Login',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '*',
    view: 'NotFound',
    dir: 'views/',
    title: 'Não Autorizado',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/',
    view: 'Login',
    title: 'Login',
    dir: 'views/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  }
]
